import Timeline from './timeline.element.js';

export default Timeline;

Timeline.define('wje-timeline', Timeline);
